<template>
  <div class="navbar">
    <!--    <hamburger-->
    <!--      :toggle-click="toggleSideBar"-->
    <!--      :is-active="sidebar.opened"-->
    <!--      class="hamburger-container"-->
    <!--    />-->
    <!--    <breadcrumb class="breadcrumb-container"/>-->

    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">报备管理</el-menu-item>
      <el-menu-item index="2">证书管理</el-menu-item>
      <el-menu-item index="3">保单管理</el-menu-item>
      <div class="right-menu">
        <el-dropdown
          class="avatar-container right-menu-item"
          trigger="click"
        >
          <div class="avatar-wrapper">
            <span class="avatar-name">{{ username }}</span>
            <i class="el-icon-caret-bottom"/>
          </div>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/admin">
              <el-dropdown-item>
                首页
              </el-dropdown-item>
            </router-link>
            <router-link to="/admin/profile">
              <el-dropdown-item>
                修改密码
              </el-dropdown-item>
            </router-link>
            <el-dropdown-item divided>
            <span
              style="display:block;"
              @click="logout"
            >{{ $t('navbar.logOut') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {getUsername} from '@/utils/auth'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    // Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(['sidebar', 'device'])
  },
  data() {
    return {
      username: '',
      activeIndex: '1'
    }
  },
  mounted() {
    if (!this.username) {
      this.username = getUsername()
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      if(key == '1'){
        this.$router.push('/admin/dashboard')
      }else if(key == '2'){
        this.$router.push('/admin/cert')
      }else if(key == '3'){
        this.$router.push('/admin/insurance')
      }
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      this.$store.dispatch('FedLogOut').then(() => {
        location.reload() // In order to re-instantiate the vue-router object to avoid bugs
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }

    .screenfull {
      height: 20px;
    }

    .international {
      vertical-align: top;
    }

    .theme-switch {
      vertical-align: 15px;
    }

    .avatar-container {
      height: 50px;
      margin-right: 30px;

      .avatar-wrapper {
        cursor: pointer;
        margin-top: -5px;
        position: relative;

        .avatar-name {
          line-height: 60px;
          vertical-align: 10px;
        }

        .user-avatar {
          vertical-align: 10px;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 30px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue